<template>
  <Teleport to="body">
    <div
      aria-modal="true"
      class="greeting-lightbox"
      role="dialog"
      :aria-label="texts.createComment.previewHeading"
    >
      <button
        aria-hidden="true"
        class="greeting-lightbox__backdrop"
        tabindex="-1"
        type="button"
        @click="$emit('close')"
      />

      <figure class="greeting-lightbox__figure">
        <video
          autoplay
          class="greeting-lightbox__media"
          controls
          playsinline
          v-if="file.type === 'video'"
          :key="file.full"
          :src="file.full"
        />
        <img
          alt=""
          class="greeting-lightbox__media"
          v-else
          :src="file.full || file.preview"
        >
        <figcaption
          class="greeting-lightbox__caption"
          v-if="file.text || file.yearTaken"
        >
          <span v-if="file.text">{{ file.text }}</span>
          <span v-if="file.yearTaken">{{ file.yearTaken }}</span>
        </figcaption>
      </figure>

      <template v-if="files.length > 1">
        <button
          class="greeting-lightbox__nav greeting-lightbox__nav--prev"
          type="button"
          :aria-label="texts.createComment.previousMedia"
          @click="step(-1)"
        >
          <svg aria-hidden="true" class="icon">
            <use href="#chevron-left" />
          </svg>
        </button>
        <button
          class="greeting-lightbox__nav greeting-lightbox__nav--next"
          type="button"
          :aria-label="texts.createComment.nextMedia"
          @click="step(1)"
        >
          <svg aria-hidden="true" class="icon">
            <use href="#chevron-right" />
          </svg>
        </button>
      </template>

      <button
        class="greeting-lightbox__close"
        type="button"
        ref="closeButton"
        :aria-label="texts.common.close"
        @click="$emit('close')"
      >
        <svg aria-hidden="true" class="icon">
          <use href="#xmark" />
        </svg>
      </button>
    </div>
  </Teleport>
</template>

<script>
  /** The preview's chosen photos and films, large, from the local files. */
  export default {
    beforeUnmount() {
      window.removeEventListener("keydown", this.onKeydown, true);
      window.removeEventListener("keyup", this.onKeyup, true);
      this.opener?.focus?.();
    },

    computed: {
      file() {
        return this.files[this.index];
      },
    },

    data() {
      return {
        index: this.start,
        opener: null,
        texts: lavendlaObituary,
      };
    },

    emits: ["close"],

    methods: {
      onKeydown(event) {
        if (event.key === "ArrowLeft") {
          this.step(-1);
        } else if (event.key === "ArrowRight") {
          this.step(1);
        }
      },

      // The greeting modal closes on Esc keyup; caught first here, it only closes the lightbox.
      onKeyup(event) {
        if (event.key === "Escape") {
          event.stopPropagation();
          this.$emit("close");
        }
      },

      step(by) {
        const count = this.files.length;
        this.index = (this.index + by + count) % count;
      },
    },

    mounted() {
      this.opener = document.activeElement;
      window.addEventListener("keydown", this.onKeydown, true);
      window.addEventListener("keyup", this.onKeyup, true);
      this.$refs.closeButton.focus();
    },
    name: "CreateCommentLightbox",

    props: {
      files: {
        required: true,
        type: Array,
      },
      start: {
        default: 0,
        type: Number,
      },
    },
  };
</script>
